import CommonModal from "./CommonModal";

import UserwisePosition from "./UserwisePosition";
import ServerwiseScriptPositionHistory from "./ServerwiseScriptPositionHistory";
import UserWiseScriptPositionHistory from "./UserWiseScriptPositionHistory";
import ScriptPositionHistoryModal from "./ScriptPositionHistoryModal";
import PositionModal from "./PositionModal";

export {
  CommonModal,
  UserwisePosition,
  ServerwiseScriptPositionHistory,
  UserWiseScriptPositionHistory,
  ScriptPositionHistoryModal,
  PositionModal,
};

// modalRegistry.js
export const modalRegistry = {
  // trade analytics
  trade_analytics_view_order: () => import("./ViewOrdersModal"),

  // trades
  trades_view_order: () => import("./TrailingOrdersModal"),

  // position
  position_details: () => import("./PositionModal"),
  position_trade_list: () => import("./TradeListModal"),
  position_userwise: () => import("./UserwisePosition"),

  // analyse device
  analyse_device_details: () => import("./DeviceDetailsModal"),

  // user
  user_add: () => import("./CreateUpdateUser"),
  user_view_access: () => import("./ViewAccessPages"),
};
